import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { makeStyles, useTheme } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import AppHeader from './components/AppHeader';
import Sidebar from './components/Sidebar';
import MainContentRouter from './components/MainContentRouter';
import Modal from './components/Modal/Modal';
// import Footer from './components/Footer';
import SnackbarMessage from './components/SnackbarMessage';
import InfoDrawer from './components/InfoDrawer/InfoDrawer';

import { setSidebar } from './reducers/sidebar';

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  root: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
  },
  main: {
    width: '100vw',
    display: 'flex',
  },
}));

const App = () => {
  const dispatch = useDispatch();

  // hide sidebar by default if on smaller screen
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (isSmallScreen) {
      dispatch(setSidebar(false));
    }
  }, [isSmallScreen]);

  const classes = useStyles();

  return (
    <>
      <InfoDrawer />
      <SnackbarMessage />
      <div className={classes.root}>
        <AppHeader />
        <Modal />
        <div className={classes.appBarSpacer} />
        <main className={classes.main}>
          <Sidebar />
          <MainContentRouter />
        </main>
        {/* <Footer /> */}
      </div>
    </>
  );
};

export default App;
